
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M43 49V26L13 49zm-7-7v-7l-9 7z","clip-rule":"evenodd"}}),_c('path',{staticClass:"i-Rectangle 2",attrs:{"stroke":"#234652","d":"M13.5 8.5h18v5h-18z"}}),_c('path',{staticClass:"i-Rectangle 3",attrs:{"stroke":"#234652","d":"M13.5 18.5h18v5h-18z"}}),_c('path',{staticClass:"i-Rectangle 4",attrs:{"stroke":"#234652","d":"M13.5 28.5h18v4.25l-3.667 2.75H13.5z"}}),_c('path',{staticClass:"i-Line 1",attrs:{"stroke":"#234652","d":"m13.5 32 5-3.5"}}),_c('path',{staticClass:"i-Line 2",attrs:{"stroke":"#234652","d":"m14.5 35.5 9-7"}}),_c('path',{staticClass:"i-Line 3",attrs:{"stroke":"#234652","d":"m19 35.5 9-7"}}),_c('path',{staticClass:"i-Line 5",attrs:{"stroke":"#234652","d":"m23.5 35.5 8-6"}}),_c('path',{staticClass:"i-Subtract",attrs:{"stroke":"#234652","d":"M38 27.622V2H7v41h10.737"}}),_c('path',{staticClass:"i-Polygon 2",attrs:{"stroke":"#234652","d":"m28.457 41.5 7.043-5.478V41.5z"}}),_c('path',{staticClass:"i-Polygon 4",attrs:{"stroke":"#234652","d":"m14.5 45.5 26-19.5v19.5z"}})])
          )
        }
      }
    